import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SpreadsheetGuide from "@/pages/sugargoo-spreadsheet-guide/page";
import ShippingGuide from "@/pages/sugargoo-shipping-guide/page";
import SugargooReview from "@/pages/sugargoo-review/page";
import Coupon from "@/pages/sugargoo-coupon/page";
import Legit from "@/pages/sugargoo-legit/page";
import Warehouse from "@/pages/sugargoo-warehouse/page";
import ShoppingGuide from "@/pages/sugargoo-shopping-guide/page";
import PrivacyPolicy from "@/pages/privacy-policy/page";
import TermsOfService from "@/pages/terms-of-service/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/sugargoo-shipping-guide",
    element: <ShippingGuide />,
  },
  {
    path: "/sugargoo-review",
    element: <SugargooReview />,
  },
  {
    path: "/sugargoo-coupon",
    element: <Coupon />,
  },
  {
    path: "/sugargoo-legit",
    element: <Legit />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <Warehouse />,
  },
  {
    path: "/sugargoo-shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;